import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

export function AuthLayout() {
  const { toggleTheme } = useTheme();

  return (
    <div className="relative overflow-hidden bg-surface-container-low dark:bg-surface-dim min-h-screen flex items-center justify-center p-gutter transition-colors duration-300">
      <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-primary/20 blur-3xl" />
      <div className="absolute -bottom-28 -right-24 h-96 w-96 rounded-full bg-tertiary/20 blur-3xl" />
      {/* Theme Toggle in Top Right */}
      <button 
        aria-label="Toggle Theme" 
        className="fixed top-gutter right-gutter p-sm rounded-full hover:bg-surface-container-high dark:hover:bg-surface transition-colors"
        onClick={toggleTheme}
      >
        <span className="material-symbols-outlined text-on-surface-variant">settings_brightness</span>
      </button>

      <Outlet />
    </div>
  );
}
